export default __webpack_public_path__ + "static/media/cases_world_trend.965524af.png";